import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import CustomButton from "../../../../components/common/button/CustomButton";
import { FINANCIAL_FIELDS } from "./allFields";
import FormField from "../../../../components/common/FormField";
import PageTitle from "../../../../components/pageTitle/PageTitle";
import { useSelector } from "react-redux";
import ManageFinancialForm from "./ManageFinancialForm";
import { useDispatch } from "react-redux";
import checked from "../../../../assets/images/checked.png";
import {
  getFinancialAction,
  setPostFinancialResponse,
} from "../../../../store/reducers/quickBookSlice";
import TableDesign, {
  TableHeading,
} from "../../../../components/common/table/TableDesign";
import Toggle from "../../../../components/common/toggle/Toggle";

const FinancialDetailPage = () => {
  const dispatch = useDispatch();
  const { userProfile } = useSelector((state: any) => state?.user);

  const [isProfessionalSection, setIsProfessionalSection] = useState(
    userProfile?.features?.includes("Professional Financial") || false // Safe fallback
  );

  useEffect(() => {
    setIsProfessionalSection(
      userProfile?.features?.includes("Professional Financial") || false
    ); // Sync profile changes
  }, [userProfile]);
  const [formData, setFormData] = useState<any>([]);
  const [open, setOpen] = useState(false);

  const { isPostFinancial, newFinancialState } = useSelector(
    (state: any) => state?.quickBook
  );

  useEffect(() => {
    dispatch(getFinancialAction());
    dispatch(setPostFinancialResponse(false));
    setOpen(false);
  }, [isPostFinancial]);

  const onChangeAction = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value } = event.target;
    setFormData((prevState: any) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const isSubmitDisabled = FINANCIAL_FIELDS.some((field) => {
    const fieldValue = formData.find(
      (item: any) => item.question_id === parseInt(field.id)
    );
    return !fieldValue || !fieldValue.question_text;
  });

  const handleSubmit = () => {
    // Submit logic here
  };

  const handleOpen = () => {
    setOpen(true);
  };
  const handleSelectedModel = () => {
    // Open add logic here
  };
  const tableHeadings1: TableHeading[] = [
    { label: "Days before work was to commence", align: "left" },
    { label: "Percentage of the total quoted price (%)", align: "left" },
  ];
  const tableHeadings2: TableHeading[] = [
    { label: "Title", align: "left" },
    { label: "Prefix", align: "left" },
    { label: "Description", align: "left" },
  ];
  const tableHeadings3: TableHeading[] = [
    { label: "Title", align: "left" },
    { label: "Description", align: "left" },
  ];

  return (
    <>
      {open && (
        <ManageFinancialForm
          open={open}
          onHide={() => setOpen(false)}
          title={newFinancialState?.id ? "Edit Financial" : "Add Financial"}
        />
      )}
      <PageTitle
        title="Financial Details"
        button={newFinancialState?.id ? "Edit" : "Add"}
        onClick={newFinancialState?.id ? handleOpen : handleOpen}
      />
      <Grid
        container
        spacing={2}
        sx={{
          padding: "10px",
          mt: 1,
          background: "#E5F4F1",
          borderRadius: "5px",
          border: "1px solid #CFCFCF",
          overflowY: "auto",
        }}
      >
        <Grid
          item
          md={12}
          xs={12}
          sx={{ paddingLeft: "0px !important", paddingRight: "16px" }}
        >
          <Grid container spacing={2}>
            {FINANCIAL_FIELDS &&
              FINANCIAL_FIELDS.filter((field) => {
                // Example: hide these fields when isProfessionalSection is true
                if (
                  !isProfessionalSection &&
                  [
                    "is_deposit_required",
                    "is_fca_registered",
                    "invoice_due_days",
                    "is_cancellation_fees_allowed",
                  ].includes(field.id)
                ) {
                  return false;
                }
                return true;
              }).map((field) => (
                <FormField
                  key={field.id}
                  // onPaste={(e) => e.preventDefault()}
                  onKeyDown={(event: any) => {
                    if (
                      event.keyCode === 8 ||
                      event.keyCode === 9 ||
                      event.keyCode === 37 ||
                      event.keyCode === 38 ||
                      event.keyCode === 39 ||
                      event.keyCode === 40 ||
                      event.keyCode === 18 ||
                      event.keyCode === 17 ||
                      event.ctrlKey
                    )
                      return event;
                    if (
                      field?.patternAllowed &&
                      !field?.patternAllowed.test(event.key)
                    ) {
                      event.preventDefault();
                    } else if (
                      field?.patternAllowed &&
                      !field?.patternAllowed.test(
                        event.target.value + event.key
                      )
                    ) {
                      event.preventDefault();
                    }
                  }}
                  {...{
                    ...field,
                    value:
                      field.id === "is_deposit_required" ||
                      field.id === "is_fca_registered" ||
                      field.id === "is_cancellation_fees_allowed" ||
                      field.id === "is_vat_included"
                        ? Boolean(newFinancialState[field.id])
                          ? "Yes"
                          : "No"
                        : newFinancialState[field.id] ?? "",
                    // value: formData[field.id] || "",
                    variant: "outlined",
                    minRows: 2,
                    isNonMarginTop: true,
                    inSingleGridForm: true,
                    onChange: onChangeAction,
                    maxLength: 250,
                    InputProps: {
                      ...(field?.inputProps && field?.inputProps),
                      sx:
                        field?.type === "text" || field?.type === "password"
                          ? { height: "36px" }
                          : {
                              padding: "6px 12px",
                              // height: "36px",
                            },
                    },
                  }}
                />
              ))}
          </Grid>
        </Grid>
        {isProfessionalSection && (
          <>
            <Grid item xs={12} md={12} sx={{ mt: 2 }}>
              <Typography
                sx={{
                  textTransform: "uppercase",
                  fontWeight: 600,
                  color: "#02906F",
                  mb: 1,
                  fontSize: "1rem",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                Cancellation Fees
                <span>
                  <Toggle
                    checked={newFinancialState?.is_cancellation_fees_allowed}
                    // onChange={() => {
                    //   setFormData((prev: any) => ({
                    //     ...prev,
                    //     is_cancellation_fees_allowed:
                    //       !prev.is_cancellation_fees_allowed,
                    //   }));
                    //   // setIsChanged(true);
                    // }}
                    disabled={true}
                    name="Is Cancellation Fees Allowed"
                  />
                  <Typography
                    component="span"
                    sx={{
                      ml: 1,
                      fontSize: "0.875rem",
                      color: "#637381",
                      fontWeight: 600,
                    }}
                  >
                    Is Cancellation Fees Allowed
                  </Typography>
                </span>
              </Typography>
              {newFinancialState?.is_cancellation_fees_allowed && (<TableDesign
                tableHeadings={tableHeadings1}
                tableHeadColor={"#02906f"}
                cellColor={"#fff"}
                pagination={
                  newFinancialState?.cancellation_fees?.length > 0 ? null : null
                }
                isLoader={false}
                stickyHeader={true}
                filterOption={""}
                setFilterOption={() => {}}
                extraCSS={{
                  height: "calc(100%)",
                }}
              >
                {newFinancialState?.cancellation_fees?.length > 0 ? (
                  newFinancialState?.cancellation_fees?.map(
                    (val: any, idx: number) => (
                      <TableRow
                        key={val?.id}
                        sx={{
                          cursor: "pointer",
                          marginTop: "10px",
                          padding: "4px !important",
                          borderRadius: "20px !important",
                          "&:hover": {
                            backgroundColor: "#f0f0f0",
                            outline: "2px solid #f0f0f0",
                            borderRadius: "0px !important",
                            outlineOffset: "-2px !important",
                          },
                        }}
                      >
                        <TableCell>{val?.days}</TableCell>
                        <TableCell>{val?.percent}</TableCell>
                      </TableRow>
                    )
                  )
                ) : (
                  <TableRow>
                    <TableCell colSpan={2}>
                      <Box
                        sx={{
                          height: "60vh",
                          display: "flex",
                          // alignItems: "center",
                          justifyContent: "center",
                          position: "relative",
                        }}
                      >
                        <span
                          style={{
                            position: "absolute",
                            fontSize: "1rem",
                            color: "#4A4A4A",
                            top: "100px",
                          }}
                        >
                          {"No Data Found."}
                        </span>
                      </Box>
                    </TableCell>
                  </TableRow>
                )}
              </TableDesign>)}
            </Grid>
            {/* invoice type */}
            <Grid item xs={12} md={12} sx={{ mt: 4 }}>
              <Typography
                sx={{
                  textTransform: "uppercase",
                  fontWeight: 600,
                  color: "#02906F",
                  mb: 1,
                  fontSize: "1rem",
                }}
              >
                Invoice Type
              </Typography>
              <TableDesign
                tableHeadings={tableHeadings2}
                tableHeadColor={"#02906f"}
                cellColor={"#fff"}
                pagination={
                  newFinancialState?.invoice_types?.length > 0 ? null : null
                }
                isLoader={false}
                stickyHeader={true}
                filterOption={""}
                setFilterOption={() => {}}
                extraCSS={{
                  height: "calc(100%)",
                }}
              >
                {newFinancialState?.invoice_types?.length > 0 ? (
                  newFinancialState?.invoice_types?.map(
                    (val: any, idx: number) => (
                      <TableRow
                        key={val?.id}
                        sx={{
                          cursor: "pointer",
                          marginTop: "10px",
                          padding: "4px !important",
                          borderRadius: "20px !important",
                          "&:hover": {
                            backgroundColor: "#f0f0f0",
                            outline: "2px solid #f0f0f0",
                            borderRadius: "0px !important",
                            outlineOffset: "-2px !important",
                          },
                        }}
                      >
                        <TableCell
                          sx={{ textAlign: "left", alignItems: "center" }}
                        >
                          <Box
                            sx={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "6px",
                            }}
                          >
                            <span>{val?.name}</span>

                            {val?.is_default && (
                              <Tooltip title="Initial Invoice Type">
                                <img
                                  src={checked}
                                  alt="initial-set"
                                  style={{
                                    height: "16px",
                                    width: "16px",
                                    display: "block",
                                  }}
                                />
                              </Tooltip>
                            )}
                          </Box>
                        </TableCell>
                        <TableCell>{val?.prefix}</TableCell>
                        <TableCell>{val?.description}</TableCell>
                      </TableRow>
                    )
                  )
                ) : (
                  <TableRow>
                    <TableCell colSpan={2}>
                      <Box
                        sx={{
                          height: "60vh",
                          display: "flex",
                          // alignItems: "center",
                          justifyContent: "center",
                          position: "relative",
                        }}
                      >
                        <span
                          style={{
                            position: "absolute",
                            fontSize: "1rem",
                            color: "#4A4A4A",
                            top: "100px",
                          }}
                        >
                          {"No Data Found."}
                        </span>
                      </Box>
                    </TableCell>
                  </TableRow>
                )}
              </TableDesign>
            </Grid>
            {/* payment method */}
            <Grid item xs={12} md={12} sx={{ mt: 4 }}>
              <Typography
                sx={{
                  textTransform: "uppercase",
                  fontWeight: 600,
                  color: "#02906F",
                  mb: 1,
                  fontSize: "1rem",
                }}
              >
                Payment Method
              </Typography>
              <TableDesign
                tableHeadings={tableHeadings3}
                tableHeadColor={"#02906f"}
                cellColor={"#fff"}
                pagination={
                  newFinancialState?.payment_methods?.length > 0 ? null : null
                }
                isLoader={false}
                stickyHeader={true}
                filterOption={""}
                setFilterOption={() => {}}
                extraCSS={{
                  height: "calc(100%)",
                }}
              >
                {newFinancialState?.payment_methods?.length > 0 ? (
                  newFinancialState?.payment_methods?.map(
                    (val: any, idx: number) => (
                      <TableRow
                        key={val?.id}
                        sx={{
                          cursor: "pointer",
                          marginTop: "10px",
                          padding: "4px !important",
                          borderRadius: "20px !important",
                          "&:hover": {
                            backgroundColor: "#f0f0f0",
                            outline: "2px solid #f0f0f0",
                            borderRadius: "0px !important",
                            outlineOffset: "-2px !important",
                          },
                        }}
                      >
                        <TableCell>{val?.name}</TableCell>
                        <TableCell>{val?.description}</TableCell>
                      </TableRow>
                    )
                  )
                ) : (
                  <TableRow>
                    <TableCell colSpan={2}>
                      <Box
                        sx={{
                          height: "60vh",
                          display: "flex",
                          // alignItems: "center",
                          justifyContent: "center",
                          position: "relative",
                        }}
                      >
                        <span
                          style={{
                            position: "absolute",
                            fontSize: "1rem",
                            color: "#4A4A4A",
                            top: "100px",
                          }}
                        >
                          {"No Data Found."}
                        </span>
                      </Box>
                    </TableCell>
                  </TableRow>
                )}
              </TableDesign>
            </Grid>
          </>
        )}
      </Grid>
    </>
  );
};

export default FinancialDetailPage;
